/**
 * Creates an environment variable accessor with SSR safety.
 * Next.js inlines `NEXT_PUBLIC_*` only when referenced statically, so each
 * app must pass its own build-time map of known env vars.
 *
 * @example
 * const getEnvVariable = createEnvAccessor({
 *   NEXT_PUBLIC_API_BASE_URL: process.env.NEXT_PUBLIC_API_BASE_URL,
 *   NODE_ENV: process.env.NODE_ENV,
 * });
 */
export const createEnvAccessor = (
  staticEnvMap: Record<string, string | undefined>
): ((key: string, fallback?: string) => string | undefined) => {
  return (key: string, fallback?: string): string | undefined => {
    if (typeof window !== 'undefined' && (window as unknown as Record<string, unknown>)[key]) {
      return (window as unknown as Record<string, unknown>)[key] as string;
    }
    return staticEnvMap[key] ?? process.env[key] ?? fallback;
  };
};

export const isClient = (): boolean => typeof window !== 'undefined';
